<script>
  import axios from 'axios';
  import {mapGetters} from 'vuex'

  export default {
    name: "",
    props: {
      id: {
        default: '',
      },
      cash: {
        default: '',
      },
      status: {
        type: Number,
        default: 0,
      },
      cashes: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      ...mapGetters({
        permission: 'permission',
      }),
      icon() {
        if (this.loading) return 'el-icon-loading';
        switch (this.status) {
          case 1:
            return 'el-icon-info';
          case 2:
            return 'el-icon-tickets';
          case 3:
            return 'el-icon-refresh';
          default:
            return 'el-icon-printer';
        }
      },
      title() {
        if (this.loading) return 'Ваш запрос выполняется';
        switch (this.status) {
          case 1:
            return 'Проверить статус';
          case 2:
            if(this.cashItem && !this.cashItem.Capabilities.CanPrintDocumentCopy) {
              return '';
            }
            return 'Дубликат';
          case 3:
            return 'Повторить попытку';
          default:
            return 'Распечатать';
        }
      },
      cashItem() {
        return (this.cashes || []).find(i => i.Id === this.cash);
      },
    },
    methods: {
      click() {
        if (this.loading) return;
        this.loading = true;
        switch (this.status) {
          case 1:
            this.getCheck()
              .then(() => {
                this.$emit('status', 2);
                this.loading = false;
              })
              .catch(() => {
                this.$emit('status', 3);
                this.loading = false;
              });
            break;
          case 2:
            this.getCopy()
              .then(({data}) => {
                this.loading = false;
                this.$emit('status', 2);
                if (!data.HasError) {
                  this.$notify.success('Операция успешно завершена');
                } else {
                  this.$notify.error(data.ResultQueryInfo.UserMessages);
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$emit('status', 3);
                console.log(err)
                this.$notify.error('Ошибка выполнения запроса');
              })
            break;
          case 3:
            this.getCheck()
              .then(() => {
                this.$emit('status', 2);
                this.loading = false;
              })
              .catch(() => {
                this.$emit('status', 3);
                this.loading = false;
              });
            break;
          default:
            this.loading = false;
            this.$emit('status', null);
            return '';
        }
      },
      getCheck() {
        return new Promise((resolve, reject) => {
          axios
            .post(
              '/tourclient/api/onlinecash/document/process',
              `OnlineCashId=${this.cash}&FiskalDocumentId=${this.id}`
            )
            .then(({data}) => {
              if (data.CheckOperationId) {
                this.getStatus(this.cash, data.CheckOperationId)
                  .then(() => {
                    switch (this.status) {
                      case 1:
                        this.$notify.success('Успешно распечатан/отправлен чек');
                        break;
                      case 2:
                        this.$notify.success('Успешно распечатан дубликат');
                        break;
                      case 3:
                        this.$notify.success('Успешно распечатан/отправлен чек');
                        break;
                      default:
                    }
                    resolve();
                  })
                  .catch(err => {
                    this.$notify.error(err);
                    reject();
                  });
              } else {
                switch (data.OperationStatusId) {
                  case 2:
                    this.$notify.success('Успешно распечатан дубликат');
                    resolve();
                    break;
                  case 3:
                    this.$notify.error(data.ResultQueryInfo.UserMessages);
                    reject();
                    break;
                }
              }
            })
        });
      },
      getCopy() {
        return new Promise((resolve) => {
          axios
            .post(
              '/tourclient/api/onlinecash/doccopy',
              `cashId=${this.cash}&fiskalDocumentId=${this.id}`
            )
            .then(resolve, resolve);
        });
      },
      getStatus(cash, id) {
        return new Promise((resolve, reject) => {
          axios
            .get(`/tourclient/api/onlinecash/document/${cash}/${id}`)
            .then(({data}) => {
              switch (data.OperationStatusId) {
                case 1:
                  setTimeout(() => {
                    this.getStatus(cash, id).then(resolve, reject);
                  }, 1000);
                  return;
                case 2:
                  resolve();
                  break;
                case 3:
                  reject(data.ResultQueryInfo.UserMessages);
                  break;
              }
            })
            .catch(() => {
              reject('Ошибка в проведении чека');
            });
        });
      }
    },
    watch: {},
    components: {},
    mounted() {
    },
    destroyed() {
    },
  }
</script>
<template>
  <el-button
    @click="click"
    :disabled="loading"
    :icon="icon"
    :title="title"
    type="primary"
    class="online-cashes-button-table"
    v-if="permission(283)&&title"
  >
  </el-button>
</template>
<style lang="scss">
  .online-cashes-button-table.el-button {
    padding: 4px 8px;
    font-size: 16px;
    margin-top: 1px;
  }
</style>
